module.exports = __webpack_public_path__ + "img/implant.b36dc9ef.png";